<template>
  <div>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>

    <article class="view__content">
      <div class="view__panel">
        <div class="multi-step">
            <Navigation :steps="steps" :currentstep="currentstep" />

            <div class="multi-step__step" v-if="currentstep == 1">
              <TextBox
                label="Label_Name"
                v-model="model.name"
                :validate="$v.model"
                v-on:input="$v.model.name.$touch"
                modelPath="name"
                acc="name"
              />
            </div>

            <div class="multi-step__step" v-if="currentstep == 2">
              <div class="cards">
                <div class="cards__item" v-for="layout in layouts" @click="chooseLayout(layout)">
                  <img class="cards__image" :src="layout.img">
                  <div class="cards__text">
                    <p>{{ layout.title }}</p>
                  </div>
                </div>
              </div>
            </div>

            <Controls
                v-if="currentstep != 3"
                v-for="step in steps"
                :step="step"
                :stepcount="steps.length"
                :currentstep="currentstep"
                :nextDisabled="step.nextDisabled"
                @step-change="stepChanged">
            </Controls>
        </div>

      </div>

      <div v-if="currentstep == 3">
        <bee
          :clientId="tenant.beeClientId"
          :clientSecret="tenant.beeClientSecret"
          :layout="currentLayout"
          @onSave="saveLayout"
        />
      </div>
    </article>
  </div>
</template>

<script>
import Bee from 'components/partials/Bee'
import { Navigation, Controls } from 'components/layout/multi-steps'
import { TextBox, Btn } from 'components/layout/forms'
import Submenu from 'components/views/templates/Submenu'
import L from 'services/Localization'
import notifications from 'mixins/notifications'
import { required } from 'vuelidate/lib/validators'
import { Validation } from 'components/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'template',
  components: { Submenu, Validation, TextBox, Btn, Navigation, Controls, Bee },
  mixins: [notifications],
  data() {
    return {
      loading: false,
      title: 'Create',
      L: L,
      model: {
        id: '',
        name: '',
        htmlContent: '',
        jsonContent: ''
      },
      currentLayout: {},
      currentstep: 1,
      indicatorclass: true,
      step: 1,
      active: 1,
      firststep: true,
      nextStep: '',
      lastStep: '',
      laststep: false,
      steps: [
        { id: 1 },
        { id: 2, nextDisabled: true },
        { id: 3 }
      ],
      tenant: {
        name: '',
        description: '',
        image: {},
        beeClientId: '',
        beeClientSecret: ''
      }
    }
  },
  beforeCreate() {
    if (this.$route.params.id) {
      this.$store.dispatch('getTemplate', this.$route.params.id).then(() => this.mapFromState())

      this.$store.dispatch('getTenantSession').then(() => {
        _.assign(this.tenant, this.currentTenant)
      })
    }
  },
  computed: {
    ...mapGetters({
      template: 'activeTemplate',
      layouts: 'templateLayouts',
      currentTenant: 'getCurrentTenant'
    })
  },
  validations: {
    model: {
      name: { required }
    }
  },
  methods: {
    stepChanged(nextStep) {
      let success = false

      // no validation if user click on 'previous' button
      if (this.currentstep > nextStep) {
        this.currentstep = nextStep
        return
      }

      switch (nextStep - 1) {
        case 1:
          if (this.isValid()) {
            success = true
            this.saveBasicInfos()
            if (!_.isEmpty(this.model.id) && !_.isEmpty(this.model.jsonContent)) {
              this.currentLayout = JSON.parse(this.model.jsonContent)
              window.console.log(this.currentLayout)
              nextStep = nextStep + 1
            }
          }
          break

        case 2:
          if (!_.isEmpty(this.currentLayout)) {
            success = true
          }
          break

        // Step 3
        case 3:
          // lol
          break
      }

      if (success) {
        this.currentstep = nextStep
      }
    },
    isValid() {
      let isValid = true
      if (this.$v.$invalid) {
        this.$v.$touch()
        isValid = false
      }
      return isValid
    },
    chooseLayout(layout) {
      this.currentLayout = layout
      this.stepChanged(this.currentstep + 1)
    },
    mapFromState() {
      _.assign(this.model, this.template)
      if (this.template) {
        this.title = this.template.name
      }
    },
    saveLayout(data) {
      this.model.htmlContent = data.html
      this.model.jsonContent = data.json
      this.saveBasicInfos()
      this.$router.push({name: 'templates'})
      this.showNotification({
        title: L.localize('Label_SuccessCreation'),
        message: L.localize('Label_Success')
      })
    },
    saveBasicInfos() {
      if (this.isValid()) {
        this.$store.dispatch('createOrUpdateTemplate', this.model).then(
          // resolve
          () => {
            this.mapFromState()
          },
          // reject
          () => {
            window.alert('error')
          }
        )
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// Template.vue?9cf645ce